<template>
  <div class="container mt-5 text-center">
    <h3>Historial</h3>
    <div v-if="loading" class="spinner-border mt-2" role="status">
      <span  class="sr-only">Loading...</span>
    </div>

    <!-- <div class="card-body p-0"> -->
      <!-- Map Container -->
      <!-- <div ref="mContainer" width="100%" height="100%" style="width: 100%; height: 180px;"></div> -->
      <!-- Countries Table List -->
      
      <div class="container">
        <div class="table-responsive">
          <table class="table" style="width:100% !important" >
            <thead>
              <tr>
                <th>Id</th>
                <th>Dirección</th>
                <th>Entrada</th>
                <th>Salida</th>
                <th>Contrato</th>
                <th>Horas</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td class="text-center">{{ item.id_diario }}</td>
                <td class="text-center">{{ item.direccion1}}</td>
                <td class="text-center">{{ item.fecha_entrada != null ? $moment(item.fecha_entrada).format('DD-MM-YYYY hh:mm') : ''  }}</td>
                <td class="text-center">{{ item.fecha_salida != null ? $moment(item.fecha_salida).format('DD-MM-YYYY hh:mm') : '' }}</td>
                <td class="text-center">{{ item.contro_id }}</td>
                <td class="text-center">{{ item.cal_hora != null ? item.cal_hora : 0 }}</td>
                <td class="text-center">
                  <button type="button" class="btn btn-primary" @click="showModal(item)">
                    Ver
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    <!-- </div> -->

  <div>
    <simple-modal v-model="isShow" title="Detalle">

      <template slot="body">
          <div v-if="loading2" class="spinner-border mt-2" role="status"></div><br>
        <!-- <h5>Detalle</h5> -->
        <textarea v-model="row.justifica" cols="55" rows="10" style="width:90%"></textarea>
        <!-- <p>Hello you</p> -->
        <button @click="saveData()" class="btn btn-primary mt-3 ml-3">Guardar</button>
        <button @click="isShow= false" class="btn btn-primary mt-3 ml-3">Cerrar</button>
      </template>
      
      <template slot="footer">
        <button>OK</button>
      </template>
    </simple-modal>
  </div>


  </div>
</template>

<script>
import SimpleModal from 'simple-modal-vue'

  import api from "../config/api";
  export default {
    components: { SimpleModal },
    data(){
      return{
        items:[],
        user: null,
        loading: false,
        isShow: false,
        row:{},
        loading2: false,
      }
    },
    async mounted(){
      this.$isLoading(true)
      this.user = JSON.parse(localStorage.getItem('user'));
      console.log('-->', this.user)
      await this.getData()
      this.$isLoading(false)

    },
    methods:{
      showModal(item){
        // this.row = item
        // this.isShow= true
        localStorage.setItem('rowhistorial', JSON.stringify(item))
        this.$router.push('detalleHistorial')

      },
      async getData(){
        let resultv = await api.request("get", '/BMGES_historial/' + this.user.numero);
        let res = resultv.data
        this.items = res
        //Ordenar lista
        this.items.sort(function (x, y) {
            return x.id_diario - y.id_diario;
        });
        //console.log('tareas', resultv)
      },
      async saveData(){
        this.loading2 = true
        let data={
          justifica : this.row.justifica
        }
        let resultv = await api.request("put", '/BMGES_actualizaHistorial/' + this.row.id_diario,  data);
        let res = resultv.data
        this.isShow= false
        await this.getData()
        this.loading2 = false
        //console.log('tareas', resultv)
      }
    }
  }

</script>

<style>

</style>